//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { animateVistatLogo } from "@/utils/vistatLogoAnimation.js";

export default {
  name: "VistatLogoAnimated",
  data() {
    return {
      timeline: null
    }
  },
  computed: {
    titleId() {
      return `vistat-logo-title-${this._uid}`
    },
    blueId() {
      return `vistat-logo-blue-${this._uid}`
    },
    shadowId() {
      return `vistat-logo-shadow-${this._uid}`
    },
    blueUrl() {
      return `url(#${this.blueId})`
    },
    shadowUrl() {
      return `url(#${this.shadowId})`
    }
  },
  mounted() {
    this.$nextTick(() => this.play())
  },
  beforeDestroy() {
    if (this.timeline) {
      this.timeline.kill()
    }
  },
  methods: {
    play(options = {}) {
      if (this.timeline && this.timeline.isActive()) return
      if (this.timeline) {
        this.timeline.kill()
      }
      this.timeline = animateVistatLogo(this.$refs.logo, options)
    },
    playFast() {
      this.play({ markerDelay: 0.45 })
    }
  }
}
